export { Divider } from './Divider';
export type { DividerProps, DividerType } from './Divider';
